export enum MarkupItemType {
    Point = 'point',
}

export const MARKUP_ITEM_TYPE_LABELS: { [type: string]: string } = {
    [MarkupItemType.Point]: 'Point',
};

export enum MarkupAction {
    Default = 'default', // Select, translate & modify
    Point = 'point',
}
